<template>
    <b-modal id="activateuser"
             size="lg"
             ref="ActivateUserModal"
             class="modal-backdrop"
             no-close-on-esc
             no-close-on-backdrop>
        <template slot="modal-header" class="mx-auto">
            <h5 class="modal-title" style="text-align:center;">Enable User</h5>
        </template>
        <template slot="default">
            <p style="background-color:#fae5e3;">
                {{activateUserMessage}}
            </p>
        </template>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button class="um-btn" @click="activateUser()">{{activateButtonText}}</b-button>
            <b-button class="um-btn" @click="cancelChanges()">Cancel</b-button>
        </template>
        <CreateUser :isNewUser="isNewUser"
                    :userEmailId="userEmailId"
                    :accountName="accountName"
                    :accountNumber="accountNumber"
                    :accountId="accountId"></CreateUser>
        <ErrorMessage :errorMessage="error"
                      callbackOnClose="cancelChanges"
                      @cancelChanges="cancelChanges"></ErrorMessage>
        <UserDisableError :message="userDisableErrorMsg" :headerMessage="userDisableHeaderMessage"></UserDisableError>
        <loading :active.sync="isLoading" :can-cancel="true" :is-full-page="fullPage"></loading>
    </b-modal>
</template>
<script>
    import service from "../../services/api.services";
    import Loading from "vue-loading-overlay";
    import CreateUser from "../CreateUser";
    import "vue-loading-overlay/dist/vue-loading.css";
    import { eventbus } from "../../main";
    import ErrorMessage from "./ErrorMessage";
    import UserDisableError from "./UserDisableError";

    export default {
        name: "ActivateUser",
        components: {
            Loading,
            ErrorMessage,
            CreateUser,
            UserDisableError
        },
        data() {
            return {
                isLoading: false,
                error: "",
                loggedInUserName: this.$store.getters.username,
                adfsUserDetails: null,
                fullPage: true,
                userDisableErrorMsg: "",
                userDisableHeaderMessage: "", 
            };
        },

        props: {
            accountNumber: String,
            accountName: String,
            accountId: String,
            userEmailId: String,
            isNewUser: Boolean,
            searchedUserDetail: {},
            activateUserMessage: String,
            activateButtonText: String
        },
        created() {
            var that = this;
            eventbus.$on("setAdfsuserDetails", function (payLoad) {
                //console.log(payLoad)
                that.adfsUserDetails = payLoad;
            });
        },
        watch: {
            searchedUserDetail: function (newValue) {
                this.searchedUserDetail = newValue;
                this.prepareActivateUserPopupData(this.searchedUserDetail);
            }
        },
        mounted() {
            var that = this;
            eventbus.$on("setAdfsuserDetails", function(data) {
                that.adfsUserDetails = data; 
                that.prepareActivateUserPopupData(that.searchedUserDetail);
                });
        },
        methods: {

            cancelChanges: function () {
                this.$bvModal.hide("activateuser");
                //this.$emit("OnCreateUserModalCancel");
            },

            activateUser: function () {
                this.activateUserStatus()
            },

            async activateUserStatus() {
                var that = this
                var userStatusObj = this.PrepareUserStatusObj()
                that.isLoading = true;
                await service.UpdateUserStatus(userStatusObj)
                    .then(response => {
                        if (response.data != null
                            && response.data.isStatusChanged == true
                            && that.searchedUserDetail.userCommunityType == "Partner User"
                            && !that.searchedUserDetail.isCustomerCommunityUser
                            && !that.searchedUserDetail.isValidPartenCommunityUser) {
                            that.$bvModal.show("UserDisableError");
                                return;
                        }
                        if (response.data!=null && response.data.isStatusChanged == true) {
                            that.isLoading = false;
                            that.$bvModal.hide("activateuser");
                            that.$bvModal.show("createuser");
                        }
                        else {
                            that.error = "error occured while Enabling user status."
                            that.$bvModal.show("errormessage");
                            that.isLoading = false;
                        }
                    })
                    .catch(error => {
                        that.isLoading = false;
                        console.log("api error:" + error);
                    });
            },

            PrepareUserStatusObj() {
                return {
                    UserName: this.searchedUserDetail.userName,
                    FirstName: this.searchedUserDetail.firstName,
                    MiddleInitial: this.searchedUserDetail.middleInitial,
                    LastName: this.searchedUserDetail.lastName,
                    Email: this.searchedUserDetail.email,
                    Title: this.searchedUserDetail.title,
                    Phone: this.searchedUserDetail.phone,
                    StreetAddress: this.searchedUserDetail.streetAddress,
                    City: this.searchedUserDetail.city,
                    State: this.searchedUserDetail.state,
                    PostalCode: this.searchedUserDetail.postalCode,
                    Country: this.searchedUserDetail.country,
                    SFAccountId: this.searchedUserDetail.sfAccountId,
                    SFContactId: this.searchedUserDetail.sfContactId,
                    AdfsGUID: this.searchedUserDetail.adfsGuid,
                    ProfileId: this.searchedUserDetail.profileId,
                    SfUserId: this.searchedUserDetail.sfUserId,
                    IsDisabled:this.adfsUserDetails.enabled,
                    LockStatus: this.adfsUserDetails.isLocked,
                    LoggedInUserName: this.loggedInUserName,
                    AccountId: this.accountId
                };
            },
            prepareActivateUserPopupData(searchedUserDetail) {
                var that = this;
                //Load Disable Partner community User Popup details
                if (searchedUserDetail.userCommunityType == "Partner User" && !searchedUserDetail.isCustomerCommunityUser &&
                    !searchedUserDetail.isValidPartenCommunityUser) {
                    that.userDisableErrorMsg = "Sorry, this action cannot be completed for this user: " +
                        "<br/> This user is a Partner contact not associated to a Partner account. " +
                        "<br/><br/> Please review the Knowledge Article: <br/>" +
                        "\"Receiving an Error When Adding Partner Contact to a Non-Partner Account in EUM\"";
                    that.userDisableHeaderMessage = "Error Message";
                }
            }
        }
    }
</script>
<style>
</style>
